module.exports = __webpack_public_path__ + "img/defalt-user.9d69ef02.png";